<nh-form [formGroup]="getForm()" [mode]="mode" (validate)="onValidate($event)">
  @if (isPartnerPortal === false && storeItem !== 'yes') {
  <div class="container start-page">
    @if (!closeAFBnudge) {
    <div>
      @if (hasIndiv) {
      <nh-nudge [message]="'NUDGETEXT_01' | globalTranslate"></nh-nudge>
      }
    </div>
    }
    <h1 class="section-header">{{ "BEFORE_YOU_BEGIN" | globalTranslate }}</h1>
    <hr />
    <div class="static-text">
      <p [innerHTML]="'START_STATIC_TEXT_1' | globalTranslate"></p>
      <p>{{ "START_STATIC_TEXT_2" | globalTranslate }}</p>
      <p>{{ "START_STATIC_TEXT_3" | globalTranslate }}:</p>
      <ul class="ps-4 mb-4">
        <li>{{ "START_STATIC_TEXT_4" | globalTranslate }}</li>
        <li>{{ "START_STATIC_TEXT_5" | globalTranslate }}</li>
        <li>{{ "START_STATIC_TEXT_6" | globalTranslate }}</li>
        <li>{{ "START_STATIC_TEXT_7" | globalTranslate }}</li>
      </ul>
      <p>{{ "START_STATIC_TEXT_8" | globalTranslate }}</p>
      <p [innerHTML]="'START_STATIC_TEXT_9' | globalTranslate"></p>
      <div class="p-3 mb-4 mt-4 helpful-tips">
        <h2 class="ps-2 sub-section">{{ "HELPFUL_TIPS" | globalTranslate }}</h2>
        <hr />
        <div class="ps-4 mb-4">
          <div class="d-flex pb-2">
            <img
              alt=""
              class="align-self-start img-responsive"
              src="../../../assets/images/Icons/HelpfulTips_CheckIcon.svg"
            />
            <div
              class="width-90 ps-3"
              [innerHTML]="'HELPFUL_TIPS_1' | globalTranslate"
            ></div>
          </div>
          <div class="d-flex pb-1">
            <img
              alt=""
              class="align-self-start img-responsive"
              src="../../../assets/images/Icons/HelpfulTips_CheckIcon.svg"
            />
            <div class="width-90 ps-3">
              {{ "HELPFUL_TIPS_2" | globalTranslate }}<br />
              <br />
              {{ "HELPFUL_TIPS_3" | globalTranslate }}
            </div>
          </div>
          <div class="d-flex">
            <img
              alt=""
              class="align-self-start img-responsive"
              src="../../../assets/images/Icons/HelpfulTips_ImportantIcon.svg"
            />
            <div class="ps-3 width-90">
              <p [innerHTML]="'HELPFUL_TIPS_4' | globalTranslate"></p>
            </div>
          </div>
        </div>
      </div>
      <div [innerHTML]="'HELPFUL_TIPS_5' | globalTranslate"></div>
    </div>
  </div>
  } @if (isPartnerPortal === true && storeItem !== 'yes') {
  <div class="container start-page">
    <h1 class="section-header">Before You Begin</h1>
    <hr />
    <div class="static-text">
      <p>
        Gather as much information before you start as possible. Questions
        throughout the application are written as if we are asking the
        applicant. <b>And</b>, the answers require input from the applicant or
        family member. If a question is required (marked with *) that means it
        must be answered for us to make a correct eigibility decision
      </p>
      <p>We will ask about things like:</p>
      <ul class="ps-4 mb-4">
        <li>
          Social Security numbers, dates of birth, and citizenship and
          immigration status for everyone applying
        </li>
        <li>
          Money from self-employment, jobs, and other income like child support
        </li>
        <li>
          Resources including vehicles, life insurance, bank accounts, homes,
          property, etc.
        </li>
        <li>
          Other health insurance information, including policy information and
          premium amounts. This also includes Medicare.
        </li>
      </ul>
      <p>
        You will also be able to add an Assisting Person as part of the
        application process. An Assisting Person can be someone who is helping
        the applicant complete ths application or it can be someone that, with
        the applicant's permission, can make decisions and talk to us on behalf
        of their household. You will be able to provide more information on this
        on the Household Information screen.
      </p>
      <p>
        At the end of the application, you must click the <b>Submit</b> button.
        This action sends your application to us and tells us you're ready for a
        decision. If approved, the start date will be the date we receive this
        application (or the date the applicant meet our rules after it's
        submitted).
      </p>
      <div class="p-3 mb-4 mt-4 helpful-tips">
        <p class="sub-section pt-3"><strong>Helpful Tips:</strong></p>
        <hr />
        <div>
          <div class="d-flex pb-3">
            <img
              alt=""
              class="align-self-start img-responsive"
              src="../../../assets/images/Icons/HelpfulTips_CheckIcon.svg"
            />
            <div class="ps-3">
              After getting started, you can stop and save your answers at any
              time by clicking the <b>Save and Exit</b> button at the bottom of
              the page. When you're ready, you can log back in and continue.
            </div>
          </div>
          <div class="d-flex pb-3">
            <img
              alt=""
              class="align-self-start img-responsive"
              src="../../../assets/images/Icons/HelpfulTips_CheckIcon.svg"
            />
            <div class="width-90 ps-3">
              We may need proof for some of your answers before we can make a
              decision. After you submit your application, you can upload
              documents if you have them with you. We'll tell you more about
              that at the end.<br />
              <br />
              What if you don't have them with you or we need more information
              from you? We'll send you a letter asking for the proof we need. Be
              sure to give us the address where you get your mail, your phone
              number, and your email address so we can reach you.
            </div>
          </div>
          <div class="d-flex">
            <img
              alt=""
              class="align-self-start img-responsive"
              src="../../../assets/images/Icons/HelpfulTips_ImportantIcon.svg"
            />
            <div class="ps-3">
              <strong>Important:</strong> When you click the <b>Next</b> button,
              you'll be asked for information about the Head of Household. By
              Head of Household, we mean the person in your home who is mostly
              responsible for taking care of this TennCare Connect account and
              your health insurance.
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  } @if (storeItem === 'yes') {
  <div class="container start-page">
    <h2 class="section-header pt-1">
      {{ "START2_STATIC_TEXT_1" | globalTranslate }}
    </h2>
    <hr />
    <div class="static-text">
      <p class="pt-2">{{ "START2_STATIC_TEXT_2" | globalTranslate }}</p>
      <p class="pt-2">{{ "START2_STATIC_TEXT_3" | globalTranslate }}</p>
      <p class="pt-3">
        <strong>TennCare Medicaid: </strong
        >{{ "START2_STATIC_TEXT_4" | globalTranslate }}
      </p>
      <p class="pt-3">
        <strong>TennCare Standard: </strong
        >{{ "START2_STATIC_TEXT_5" | globalTranslate }}
      </p>
      <p class="pt-3">
        <strong>CoverKids: </strong>
        {{ "START2_STATIC_TEXT_6" | globalTranslate }}
      </p>
      <p class="pt-3">
        <strong>{{ "START2_STATIC1_TEXT_7" | globalTranslate }}: </strong
        >{{ "START2_STATIC2_TEXT_7" | globalTranslate }}
      </p>
      <p class="pt-3">
        <strong>Katie Beckett: </strong
        >{{ "START2_STATIC_TEXT_8" | globalTranslate }}
      </p>
      <div>
        {{ "START2_STATIC_TEXT_9" | globalTranslate }}
        <b>{{ "NEXT" | globalTranslate }} </b
        >{{ "START2_STATIC_TEXT_10" | globalTranslate }}
      </div>
    </div>
  </div>
  }
</nh-form>